let collapsibles = document.getElementsByClassName("collapsible");
let i;

for (i = 0; i < collapsibles.length; i++) {
  collapsibles[i].addEventListener("click", function(e) {
    e.preventDefault();  
    e.stopPropagation();
    this.classList.toggle("collapsible-active");
    let content = this.nextElementSibling;
    if (content.style.display === "block") {
      content.style.display = "none";
    } else {
      content.style.display = "block";
    }
  });
}
